import containerTemplate from './template'
import { create, ZoidComponent } from 'zoid/dist/zoid.frameworks'
import { commonComponentsProps } from '../common/props'

import defaultLoader from '../common/defaultLoaderTemplate'

const cdc: ZoidComponent = create({
  tag: 'mbo-cdc-modal-wrapper',

  url: ({ props }) => props.url,

  context: 'iframe',

  dimensions: {
    width: '100%',
    height: '100%',
  },

  containerTemplate,

  prerenderTemplate: defaultLoader,

  props: {
    ...commonComponentsProps,

    url: {
      type: 'string',
      required: true,
    },

    onModuleAction: {
      type: 'function',
      required: false,
    },

    onModuleLoading: {
      type: 'function',
      required: false,
    },
  },
})

export default cdc
